export const getDenominationsList = () => {
	return [
		'Anglican',
		'Baptist',
		'Episcopalian',
		'Lutheran',
		'Methodist',
		'Non-Denominational',
		'Pentecostal',
		'Presbyterian',
		'Reformed',
		'Seventh-day Adventist',
		'Wesleyan',
		'Other',
	];
};
